import {Component, HostListener, Injector, OnInit} from '@angular/core';
import {AppComponent} from '../../app.component';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {Planos} from '../../core/viewModel/planos.model';
import {COUNT_DIARIAS_DEFAULT} from '../../app.constants';
import {Proposta} from '../../core/viewModel/proposta.model';
import {CategoriaPlanoService} from '../../core/services/categoria_plano.service';
import {ProdutoService} from '../../core/services/produto.service';
import {BaseComponents} from '../base-components';

@Component({
  selector: 'app-tabela-diarias-facilita',
  templateUrl: './tabela-diarias-facilita.component.html',
  styleUrls: ['./tabela-diarias-facilita.component.sass']
})
export class TabelaDiariasFacilitaComponent extends BaseComponents implements OnInit {

  minDiaria: number = COUNT_DIARIAS_DEFAULT;
  typeValues = [{value: 2, label: 'Duplo'}, {value: 3, label: 'Triplo'}];
  selectedTypeValue = 2;
  planosDuplos: Planos[] = [];
  planosTriplos: Planos[] = [];
  planos: Planos[] = [];
  plano: Planos;
  selectedCategoria: any;
  valoresPlanoList: any = [];
  categoriaTitulo: string;
  propostaResult: Proposta;
  text1: string;
  text2: string;
  valorMensal: any;
  isMobile = false;
  public innerWidth: any;

  constructor(
      private produtoService: ProdutoService,
      protected injector: Injector,
      private categoriaPlanoService: CategoriaPlanoService,
      private appComponent: AppComponent,
      protected toast: ToastrService,
      protected router: Router
  ) { super(injector); }
  @HostListener('window:resize', ['$event'])
  onResize($event: Event) {
    this.handleMobile();
  }
  async ngOnInit() {
    this.handleMobile();
    await this.getPlanos();
  }
  async getPlanos() {
    this.appComponent.showOverlay();
    const data = await this.produtoService.planos();
    this.planosDuplos = this.categoriaPlanoService.onlyDoubles(data, this.minDiaria);
    this.planosTriplos = this.categoriaPlanoService.onlyTriples(data, this.minDiaria);
    this.planos = this.planosDuplos;
    this.selectedCategoria = (this.planosDuplos !== null && this.planosDuplos.length) ? this.planos[1].codigoCategoria : '';
    this.calculaValores();
    this.appComponent.hideOverlay();
  }

  async persistirProposta() {
    const {notAvailable, message, title} = this.isMaintenance();
    if (notAvailable) {
      this.toast.error(message, title, { timeOut: 5000});
      return;
    }
    this.propostaResult = {
      cupom:  '',
      cupomId: null,
      cupomAceito: false,
      fidelizacaoCliente: true,
      itensProposta: [{
        categoriaTitulo: this.categoriaTitulo,
        diarias: this.minDiaria,
        pessoas: (this.selectedTypeValue === 1) ? 2 : 3,
        quartos: 1,
        valor: this.plano.qtdDiarias[0].valor,
        valoresTitulosDetalhado: [{
          categoriaDescricao: this.plano.descricao,
          codigoCategoria: this.plano.codigoCategoria,
          descricao: this.plano.qtdDiarias[0].descricao,
          qtdTitulos: this.plano.qtdDiarias.length,
          quantidadeDiarias: this.plano.qtdDiarias[0].quantidadeDiarias,
          valor: this.plano.qtdDiarias[0].valor
        }]
      }],
      mensagemCupom: '',
      valorAdesao: 'R$ 600,00',
      valorMensalidade: this.valorMensal,
      valorAdesaoDesconto: 0,
      valorMensalidadeDesconto: 0,
      quartoTriplo: (this.selectedTypeValue === 3) ? 1 : 0,
      quartoDuplo: (this.selectedTypeValue === 2) ? 1 : 0
    };
    localStorage.setItem('mtl.proposta', JSON.stringify(this.propostaResult));
    await this.router.navigate(['faca-parte']);
  }

  onChangeType(event) {
    this.selectedTypeValue = +event;
    this.planos =  (this.selectedTypeValue === 2) ? this.planosDuplos : this.planosTriplos;
    this.selectedCategoria = this.categoriaPlanoService.transitionType(this.selectedCategoria);
    this.calculaValores();
  }

  onChangeCategoria(event) {
    this.selectedCategoria = event;
    this.calculaValores();
  }

  calculaValores() {
    let categorias = [];
    let categoria = null;
    let quantidadesDiarias = [];
    const data = [];
    categorias = this.planos.filter(value => value.codigoCategoria === this.selectedCategoria);
    if (categorias.length > 0) {
      categoria = categorias[0];
      this.plano = categoria;
      this.categoriaTitulo = categoria.descricao;
      quantidadesDiarias = categoria.qtdDiarias;
      this.valorMensal = this.categoriaPlanoService.monthlyValueString(quantidadesDiarias[0].descricao);
      quantidadesDiarias.forEach(value => {
        const total = (value.valor * 12).toFixed(2);
        const object = {
          quantidade_diarias: value.quantidadeDiarias,
          valor: this.categoriaPlanoService.monthlyValueString(value.descricao),
          totalAno: this.transformCoin(total)
        };
        data.push(object);
      });
      this.valoresPlanoList = data;
      this.setText();
    }
  }

  transformCoin(total: string) {
    const totalSeparado = total.split('.');
    const total1 = totalSeparado[0];
    const total2 = totalSeparado[1];
    let soma;
    if (total1.length === 4) {
      soma = 'R$ ' + total1[0] + '.' + total1[1] + total1[2] + total1[3] + ',' + total2;
    }
    if (total1.length === 5) {
      soma = 'R$ ' + total1[0] + total1[1] + '.' + total1[2] + total1[3] + total1[4] + ',' + total2;
    }
    return soma;
  }

  setText() {
    const codigoCategoria = this.plano.codigoCategoria;
    const valor = this.valoresPlanoList[0].valor;
    this.text1 = this.categoriaPlanoService.getText(0, codigoCategoria, valor);
    this.text2 = this.categoriaPlanoService.getText(2, codigoCategoria, valor);
  }

  categoriaTituloDescritivo() {
    return this.categoriaTitulo;
  }

  handleMobile() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 1026) {
      this.isMobile = true;
      return;
    }
    this.isMobile = false;
  }
}
